module.exports = __webpack_public_path__ + "static/media/eficiencia.a40bf073.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/eficiencia.jpg
// module id = 84
// module chunks = 0